var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLockAccountProcedure = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.446,
    height: 18,
    viewBox: "0 0 18.446 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_lock_account_procedure",
    d: "M389.832,585.908h-.649v-.869A3.033,3.033,0,0,0,386.157,582h0a3.03,3.03,0,0,0-3.023,3.039v.869h-.649a.217.217,0,0,0-.215.218v5.425a.868.868,0,0,0,.865.869h6.05a.868.868,0,0,0,.864-.869v-5.425A.217.217,0,0,0,389.832,585.908Zm-3.047,3.213.177,1.583v.005a.275.275,0,0,1-.246.3h-1.139a.279.279,0,0,1-.278-.279V590.7l.176-1.582a1.1,1.1,0,0,1-.455-.9v0a1.112,1.112,0,0,1,1.108-1.07h.046a1.088,1.088,0,0,1,.611,1.971Zm1.125-3.258h-3.5v-.88a1.752,1.752,0,1,1,3.5,0Zm-6.373,6.639a1.867,1.867,0,0,0,.187.374,23.654,23.654,0,0,1-2.505.124h-.154c-7.061-.035-7.554-2.319-7.452-3.256a6.949,6.949,0,0,1,4.2-6.008.718.718,0,0,1,.225-.033,1.125,1.125,0,0,1,.686.245,3.7,3.7,0,0,0,4.751.024,1.118,1.118,0,0,1,.675-.24.748.748,0,0,1,.2.031,4.006,4.006,0,0,0-.225,1.2,1.222,1.222,0,0,0-.864,1.164v5.425A1.859,1.859,0,0,0,381.537,592.5Zm-6.275-13.515a3.823,3.823,0,1,1,3.819,3.988A3.906,3.906,0,0,1,375.262,578.987Z",
    transform: "translate(-371.602 -575)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLockAccountProcedure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_lock_account_procedure.6570f54484091b54e33de45e2606c8f1.svg";